import { lazy } from 'react';

const Payment = lazy(() =>  import('../pages/Payment/Payment'));
const Completed = lazy(() =>  import('../pages/Payment/Completed'));

export default [{
    path: "/payment",
    element: Payment,
    analytics: { name: ["Pagamento"]},
}, {
    path: "/payment/completed",
    element: Completed,
    analytics: { name: ["Pagamento", "Completato"]},
}]
